import type { FC } from 'react'
import Link from 'next/link'
import useRecipientUsers from '../../../recipient/hooks/useRecipientUsers'
import RecipientCard from '../../../recipient/RecipientCard'
import { PencilSquareIcon } from '@heroicons/react/24/outline'
import LoginButton from '../../../shared/LoginButton'
import { MinimalistButton } from '@g4g/ui/src/internal/buttons/MinimalistButton'

const CheckoutPaymentRecipient: FC = () => {
  const { currentRecipient, loading } = useRecipientUsers()

  return (
    <>
      {!loading && (
        <div className="lg:order-0">
          {currentRecipient ? (
            <>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center text-sm text-white/50">
                  <span>Recipient</span>
                </div>
                <Link
                  href="/recipient"
                  className="flex items-center space-x-1 text-white/80 hover:text-white"
                >
                  <PencilSquareIcon className="w-4 h-4" />
                  <span className="text-base">Edit</span>
                </Link>
              </div>
              <Link href="/recipient">
                <RecipientCard recipient={currentRecipient} checked={false} />
              </Link>
            </>
          ) : (
            <div className="flex flex-col mt-6 space-y-4">
              <p className="text-sm text-white/80">
                Log in to your account that is connected to the game or search users to gift
                anonymously
              </p>
              <LoginButton primary />
              <MinimalistButton
                className="h-12"
                props={{
                  full: true,
                  mainColor: '#e08e0b',
                  buttonText: 'Search users',
                  href: '/recipient',
                  as: 'link',
                }}
                data-cy="shop-checkout-search-users"
              />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default CheckoutPaymentRecipient
